/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileURL } from '../models/FileURL';
import type { ID } from '../models/ID';
import type { MissionReportResponse } from '../models/MissionReportResponse';
import type { MissionReportSearchResults } from '../models/MissionReportSearchResults';
import type { UUID } from '../models/UUID';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ReportsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Search all available mission reports.
   * @param search
   * @param limit
   * @returns MissionReportSearchResults The mission report search results.
   * @throws ApiError
   */
  public searchReports(
    search?: string,
    limit: number = 100,
  ): CancelablePromise<MissionReportSearchResults> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/reports',
      query: {
        'search': search,
        'limit': limit,
      },
      errors: {
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
      },
    });
  }

  /**
   * Get the report for a closed mission.
   * @param missionId The ID of the mission.
   * @param response
   * @param accept
   * @returns MissionReportResponse The mission report.
   * @throws ApiError
   */
  public getReport(
    missionId: string,
    response: 'redirect' | 'url' | 'data' = 'data',
    accept: string = 'application/json',
  ): CancelablePromise<MissionReportResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/reports/{missionId}',
      path: {
        'missionId': missionId,
      },
      headers: {
        'accept': accept,
      },
      query: {
        'response': response,
      },
      errors: {
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
        404: `The object was not found.`,
      },
    });
  }

  /**
   * Get a binary file for a report
   * @param missionId The ID of the mission
   * @param fileId The ID of the file to create.
   * @param noRedirect
   * @returns FileURL The URL to the file.
   * @throws ApiError
   */
  public getReportFile(
    missionId: UUID,
    fileId: ID,
    noRedirect?: boolean,
  ): CancelablePromise<FileURL> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/reports/{missionId}/files/{fileId}',
      path: {
        'missionId': missionId,
        'fileId': fileId,
      },
      query: {
        'noRedirect': noRedirect,
      },
      errors: {
        302: `The object is found.`,
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
        404: `The object was not found.`,
      },
    });
  }

}
